/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 * The styled components for the widget Search Accounts
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { Button } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

import { ONBOARDING_DATA_ATTR } from '@/main/modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '@/main/modules/onboarding/types/onboardingTypes';
import { colors } from '@/main/theme';

export const FastActionsPlateLayoutStyled = styled.div.attrs({
    'data-module': 'fastActionsPlate',
    [ONBOARDING_DATA_ATTR]: EOnboardingComponentsId.fastActionsPlate,
})`
    margin: 24px 40px 0 40px;
`;

export const FastActionsPlateContainerStyled = styled.div`
    position: relative;
`;

export const FastActionsPlateDisplayContainerStyled = styled.div`
    width: 100%;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${colors.accountSelectDisplayBgColorDefault};
    padding: 11px 56px 11px 20px;
    cursor: pointer;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.09);
`;

export const VerticalSeparateLineStyled = styled.div`
    border-right: 1px solid ${colors.borderColorNormal};
    opacity: .2;
    height: 30px;
`;

export const FastActionButtonStyled = styled(Button)`
    gap: 6px;
`;

export const FastActionButtonsArrayStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
`
